import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useUser, SignInButton } from '@clerk/clerk-react';
import { Hero } from './landing/Hero';
import { ProblemAgitation } from './landing/ProblemAgitation';
import { Pricing } from './landing/Pricing';
import { HowItWorks } from './landing/HowItWorks';
import { SocialProof } from './landing/SocialProof';
import { Features } from './landing/Features';
import { FAQ } from './landing/FAQ';
import { CTAFinale } from './landing/CTAFinale';
import { Footer } from './landing/Footer';
import { Button } from '@/components/ui/button';
import { ScrollReveal } from './ui/decorative/ScrollReveal';

const LandingPageV2: React.FC = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  const { user } = useUser();

  return (
    <div className="min-h-screen bg-cream-paper text-charcoal font-body selection:bg-bottle-green selection:text-white">
      <div className="bg-grain-enhanced" />

      <div className="relative z-10">
        <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b border-aged-brass/10 bg-cream-paper/90">
          <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
            <div className="font-display font-bold text-2xl tracking-tighter text-charcoal">
              Vantage<span className="text-bottle-green">Draft</span>
            </div>

            <div className="hidden md:flex items-center gap-10 text-sm font-medium text-muted-warm">
              <a href="#pricing" className="hover:text-bottle-green transition-colors link-underline-hover">Pricing</a>
              <a href="#how-it-works" className="hover:text-bottle-green transition-colors link-underline-hover">How it works</a>
              <a href="#features" className="hover:text-bottle-green transition-colors link-underline-hover">Features</a>
            </div>

            <div className="flex items-center gap-4">
              {isSignedIn ? (
                <>
                  <span className="text-sm font-medium text-muted-warm hidden sm:block">
                    {user?.firstName || user?.emailAddresses[0].emailAddress}
                  </span>
                  <Button
                    onClick={() => navigate('/dashboard')}
                    className="bg-charcoal text-white hover:bg-bottle-green transition-colors rounded-lg"
                  >
                    Go to Dashboard
                  </Button>
                </>
              ) : (
                <>
                  <SignInButton mode="modal">
                    <button type="button" className="text-sm font-medium text-muted-warm hover:text-bottle-green transition-colors hidden sm:block">
                      Log in
                    </button>
                  </SignInButton>
                  <SignInButton mode="modal">
                    <button type="button" className="bg-bottle-green text-white px-5 py-2.5 rounded-lg text-sm font-bold hover:bg-sage transition-colors shadow-md">
                      Get Started
                    </button>
                  </SignInButton>
                </>
              )}
            </div>
          </div>
        </nav>

        <main>
          <ScrollReveal>
            <Hero />
          </ScrollReveal>
          <ScrollReveal>
            <ProblemAgitation />
          </ScrollReveal>
          <div id="pricing">
            <ScrollReveal>
              <Pricing />
            </ScrollReveal>
          </div>
          <div id="how-it-works">
            <ScrollReveal>
              <HowItWorks />
            </ScrollReveal>
          </div>
          <ScrollReveal>
            <SocialProof />
          </ScrollReveal>
          <div id="features">
            <ScrollReveal>
              <Features />
            </ScrollReveal>
          </div>
          <div id="faq">
            <ScrollReveal>
              <FAQ />
            </ScrollReveal>
          </div>
          <ScrollReveal>
            <CTAFinale />
          </ScrollReveal>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default LandingPageV2;
